import {useMutation} from '@tanstack/react-query'

import {toast} from 'react-toastify'
import useRequestParams from 'src/feature/bite/hook/request'
import {useMarket} from '../hook'
import {API} from 'src/feature/bite/domain'

export function useAddCart() {
  const {auth, headers, errors} = useRequestParams()

  return useMutation(
    ['AddProductToBasket'],
    async (values: any) => {
      const Response = await fetch(`${API}/Basket/AddProductToBasket`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          ...values,
          userID: auth()?.id,
        }),
      })

      const Data = await Response.json()

      if (!Response.ok || !Data.responseResult.result) {
        toast.error(errors.basket.error, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })

        return
      }

      toast.success(errors.basket.success, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })

      return true
    },
    {
      onSuccess: () => {},
      onError: (error) => {},
    }
  )
}

export function useRemoveCart() {
  const {auth, headers, errors} = useRequestParams()

  return useMutation(
    ['RemoveProductFromBasket'],
    async (values: any) => {
      const Response = await fetch(`${API}/Basket/RemoveProductFromBasket`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          ...values,
          userID: auth()?.id,
        }),
      })

      const Data = await Response.json()

      if (!Response.ok || !Data.responseResult.result) {
        toast.error(errors.basket.error, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })

        return
      }

      toast.success(errors.basket.success, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })

      return true
    },
    {
      onSuccess: () => {},
      onError: (error) => {
        console.log(error)
      },
    }
  )
}

export function useRemoveBasket() {
  const {basketIdSet} = useMarket()
  const {auth, headers, errors} = useRequestParams()

  return useMutation(
    ['removeBasket'],
    async (values: any) => {
      const Response = await fetch(`${API}/Basket/DeleteBasket`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          ...values,
          userID: auth()?.id,
        }),
      })

      const Data = await Response.json()

      if (!Response.ok || !Data.responseResult.result) {
        toast.error(errors.basket.error, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })

        return
      }

      const ResponseBasket = await fetch(`${API}/Basket/CreateBasket`, {
        method: 'POST',
        headers,
        body: JSON.stringify({userID: auth()?.id}),
      })
      const DataBasket = await ResponseBasket.json()

      basketIdSet(DataBasket.response.basketId)

      return true
    },
    {
      onSuccess: () => {},
      onError: (error) => {},
    }
  )
}
